import React from "react";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router-dom";
import { HeaderViewCommonBlockItem } from "app/components/header/sub-components/expanded-view/data";
import { ReactComponent as UserGuideIcon } from "app/assets/vectors/HeaderResourcesViewUserGuide.svg";
import { ReactComponent as DataServicesIcon } from "app/assets/vectors/HeaderResourcesViewDataServices.svg";
import { useCMSData } from "app/hooks/useCMSData";
import { getCMSDataField } from "app/utils/getCMSDataField";

export const HeaderResourcesView: React.FC = () => {
  const cmsData = useCMSData({ returnData: true });
  const items = [
    {
      title: getCMSDataField(cmsData, "general.userGuideText", "User Guide"),
      icon: UserGuideIcon,
      subtitle: getCMSDataField(
        cmsData,
        "componentsHeader.userGuideSubText",
        "Read FAQ, search for tutorials and information on AIDA."
      ),
      link: "https://support.aida.tools",
      external: true,
    },
    {
      title: getCMSDataField(
        cmsData,
        "general.dataServicesText",
        "Data Services"
      ),
      icon: DataServicesIcon,
      subtitle: getCMSDataField(
        cmsData,
        "componentsHeader.dataServicesSubText",
        "Read on our Service Offers, AIDA product and tools."
      ),
      link: "/data-services?v=publisher",
    },
    {
      title: getCMSDataField(
        cmsData,
        "componentsHeader.contactText",
        "Contact"
      ),
      icon: DataServicesIcon,
      subtitle: getCMSDataField(
        cmsData,
        "componentsHeader.contactSubText",
        "If you have any questions about AIDA, The Open Data Company or any other requests."
      ),
      link: "/contact",
    },
  ];
  const location = useLocation();
  const [activeButton, setActiveButton] = React.useState<string>("");

  const onPathnameChange = (value: string) => {
    switch (value) {
      case items[0].link:
        return items[0].title;
      case items[1].link.split("?")[0]: // Handle the case where the link has query parameters
        return items[1].title;
      default:
        return "";
    }
  };

  React.useEffect(() => {
    const newActiveButton = onPathnameChange(location.pathname);
    if (newActiveButton !== activeButton) {
      setActiveButton(newActiveButton);
    }
  }, [location.pathname]);

  return (
    <Grid container spacing={2}>
      {items.map((item) => (
        <Grid item xs={12} md={12} lg={4} xl={3} key={item.title}>
          <HeaderViewCommonBlockItem
            title={item.title}
            link={item.link}
            icon={<item.icon />}
            subtitle={item.subtitle}
            external={item.external}
            active={activeButton === item.title}
          />
        </Grid>
      ))}
    </Grid>
  );
};
